function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "b"
}, React.createElement("rect", {
  width: 48,
  height: 48
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "a",
  clipPath: "url(#b)"
}, React.createElement("path", {
  d: "M50.693,21.4H45.535v-.688A3.011,3.011,0,0,0,42.383,17.9h-6.82a3.011,3.011,0,0,0-3.152,2.808V21.4H27.252A3.18,3.18,0,0,0,24.1,24.548v.4a3.232,3.232,0,0,0,2.121,2.98V51.542a3.18,3.18,0,0,0,3.152,3.152h19.2a3.18,3.18,0,0,0,3.152-3.152V27.93a3.1,3.1,0,0,0,2.121-2.98v-.4A3.18,3.18,0,0,0,50.693,21.4ZM34.13,20.708a1.31,1.31,0,0,1,1.433-1.089h6.82a1.31,1.31,0,0,1,1.433,1.089V21.4H34.13ZM48.573,52.975H29.315a1.419,1.419,0,0,1-1.433-1.433V28.1H49.948V51.542A1.372,1.372,0,0,1,48.573,52.975Zm3.553-28.026a1.419,1.419,0,0,1-1.433,1.433h-23.5a1.419,1.419,0,0,1-1.433-1.433v-.4a1.419,1.419,0,0,1,1.433-1.433H50.636a1.419,1.419,0,0,1,1.433,1.433v.4Z",
  transform: "translate(-14.509 -11.695)"
}), React.createElement("path", {
  d: "M41.859,39.7a.88.88,0,0,0-.859.859V58.3a.859.859,0,1,0,1.717,0V40.559A.88.88,0,0,0,41.859,39.7Z",
  transform: "translate(-21.722 -20.971)"
}), React.createElement("path", {
  d: "M56.859,39.7a.88.88,0,0,0-.859.859V58.3a.859.859,0,1,0,1.717,0V40.559A.88.88,0,0,0,56.859,39.7Z",
  transform: "translate(-28.125 -20.971)"
}));

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Trash.10b1bdc0.svg";
export { ForwardRef as ReactComponent };